"use strict";

var messagesWidget = function () {
  var messageTemplate = '';
  var messageTemplateGroup = '';
  var mssgsWidgetParams = {
    model: {},
    url: {},
    template: {},
    shownMssgsCount: 5,
    searchQuery: ''
  };
  var isSearchMode = false;
  var $mssgsLoader = null;

  function renderResults(mssgs, shouldAppend) {
    var $mssgsList = $('.mssgs-group');
    var $moreMssgsBtn = $('#moreMssgsBtn');
    var template = messageTemplate;

    if (mssgs.MessageFilter == 0) {
      template = messageTemplateGroup;
    }

    if (shouldAppend) {
      $mssgsList = $moreMssgsBtn.prev('.mssgs-wrap').find('.mssgs-group');
      $mssgsList.append(template.render(mssgs));
    } else {
      $mssgsList.html(template.render(mssgs));
    }

    if (mssgs.HasMoreMessages) {
      $moreMssgsBtn.show();
    } else {
      $moreMssgsBtn.hide();
    }
  }

  function getMessages(filter, skip, search, callback) {
    $.ajax({
      url: "".concat(mssgsWidgetParams.url.getMssgs).concat(filter, "/").concat(skip, "/").concat(mssgsWidgetParams.model.id, "/").concat(search),
      type: 'GET',
      success: function success(data) {
        callback(data);
      }
    });
  }

  function getServiceModalTemplate(serviceId, entityId, callback) {
    $.ajax({
      url: "".concat(mssgsWidgetParams.url.serviceInstanceCard, "/Create/").concat(serviceId, "/").concat(entityId),
      type: 'GET',
      success: function success(template) {
        callback(template);
      }
    });
  }

  function refreshMssgsList(foundMssgs) {
    var $searchResultsTitle = $('.mssgs-search-results');
    var $searchResultsCount = $('.mssgs-search-count');
    $searchResultsTitle.hide();
    $searchResultsCount.empty();

    if (foundMssgs.MessageFilter == 0 && foundMssgs.WidgetMode != 3) {
      mssgsWidgetParams.shownMssgsCount = foundMssgs.Groups.length;
    } else {
      mssgsWidgetParams.shownMssgsCount = foundMssgs.Messages.length;
    }

    renderResults(foundMssgs);
  }

  function setParams(mssgsParams) {
    mssgsWidgetParams = $.extend({}, mssgsWidgetParams, mssgsParams);
  }

  function cacheNodes() {
    // $mssgsLoader = $('.tabContent > .loader.-local');
    $mssgsLoader = $('.appartment-mssgs > .loader.-local');
  }

  function compileTemplates() {
    messageTemplateGroup = Hogan.compile(mssgsWidgetParams.template.group);
    messageTemplate = Hogan.compile(mssgsWidgetParams.template.mssg);
  }

  function bindHandlers() {
    $(document).on('click', '#searchMssgsBtn', function () {
      var $mssgsHeader = $('.appartment-mssgs-header');
      $mssgsHeader.addClass('-search-mode');
    });
    $(document).on('click', '#closeSearchMssgs', function () {
      var $mssgsHeader = $('.appartment-mssgs-header');
      var $mssgsSearchField = $('#searchMssgsField');
      $mssgsHeader.removeClass('-search-mode');
      $mssgsSearchField.val('');
      mssgsWidgetParams.searchQuery = '';
      isSearchMode = false;
      getMessages(mssgsWidgetParams.model.filter, 0, mssgsWidgetParams.searchQuery, refreshMssgsList);
    });
    $(document).on('keyup', '#searchMssgsField', function (e) {
      var searchQuery = $(this).val();
      mssgsWidgetParams.searchQuery = searchQuery;
      isSearchMode = true;

      if (searchQuery.length > 2 || e.which === 13) {
        $mssgsLoader.show();
        var filter = mssgsWidgetParams.model.filter;
        getMessages(filter, 0, mssgsWidgetParams.searchQuery, function (foundMssgs) {
          var $searchResultsTitle = $('.mssgs-search-results');
          var $searchResultsCount = $('.mssgs-search-count');
          $mssgsLoader.hide();
          $searchResultsTitle.show();
          $searchResultsCount.text(foundMssgs.MessageAllCount);

          if (foundMssgs.MessageFilter == 0 && foundMssgs.WidgetMode != 3) {
            mssgsWidgetParams.shownMssgsCount = foundMssgs.Groups.length;
          } else {
            mssgsWidgetParams.shownMssgsCount = foundMssgs.Messages.length;
          }

          renderResults(foundMssgs);
        });
      }
    });
    $(document).on('click', '#moreMssgsBtn', function () {
      var filter = mssgsWidgetParams.model.filter;
      getMessages(filter, mssgsWidgetParams.shownMssgsCount, mssgsWidgetParams.searchQuery, function (foundMssgs) {
        if (foundMssgs.MessageFilter == 0 && foundMssgs.WidgetMode != 3) {
          mssgsWidgetParams.shownMssgsCount += foundMssgs.Groups.length;
        } else {
          mssgsWidgetParams.shownMssgsCount += foundMssgs.Messages.length;
        }

        renderResults(foundMssgs, true);
      });
    });
    $(document).on('click', '.mssg-section-link', function (e) {
      // var $loader = $(document).find('.appartment-mssgs > .loader.-local'); 
      //  $loader.show();
      e.preventDefault();
      var $this = $(this);
      var currentFilter = $this.attr('data-filter');
      var $mssgsFilter = $('#MessageFilter'); // update model

      $mssgsFilter.val(currentFilter);
      mssgsWidgetParams.model.filter = currentFilter;
      mssgsWidgetParams.searchQuery = ''; // switch selected tab

      $('.mssgs-sections .tab').removeClass('-active');
      $this.parent().addClass('-active'); // render mssgs list

      $mssgsLoader.show();
      getMessages(mssgsWidgetParams.model.filter, 0, mssgsWidgetParams.searchQuery, function (foundMssgs) {
        $mssgsLoader.hide();

        if (foundMssgs.MessageFilter == 0 && foundMssgs.WidgetMode != 3) {
          mssgsWidgetParams.shownMssgsCount = foundMssgs.Groups.length;
        } else {
          mssgsWidgetParams.shownMssgsCount = foundMssgs.Messages.length;
        }

        renderResults(foundMssgs);
        window.history.replaceState('', 'Title', $this.attr('href'));
      }); // $loader.hide();
    });
    $(document).on('click', '.appartment-mssgs-services .service-group', function () {
      var $this = $(this);
      $this.toggleClass('-open-menu');
    });
    $(document).on('click', '.appartment-mssgs-services .service-item', function () {
      var serviceId = $(this).data('serviceid');
      var entityId = $(this).data('entityid');

      if (serviceId !== '') {
        modalDialog.busyIndicator(true);
        getServiceModalTemplate(serviceId, entityId, function (template) {
          var $mssgServiceModal = $('#mssgsServiceModal').html(template);
          modalDialog.busyIndicator(false);
          $mssgServiceModal.showAsModal({
            isVertical: true,
            buttons: [{
              title: 'Отправить',
              big: true,
              primary: true,
              wide: true,
              onClick: function onClick() {
                var isValid = modalService.validateModalForm();
                var $mssgsHeader = $('.appartment-mssgs-header');
                var $mssgsSearchField = $('#searchMssgsField');

                if (isValid) {
                  // improve submitRequest API
                  modalService.submitRequest(function (res) {
                    if (res.Success) {
                      modalDialog.showBaseWnd({
                        title: 'Запрос принят',
                        buttons: [{
                          title: 'Хорошо',
                          big: true,
                          primary: true
                        }],
                        onDrawContent: function onDrawContent() {
                          return res.Result;
                        }
                      });
                    } else {
                      modalDialog.showBaseWnd({
                        title: 'Ошибка',
                        buttons: [{
                          title: 'Хорошо',
                          big: true,
                          primary: true
                        }],
                        onDrawContent: function onDrawContent() {
                          return res.Result;
                        }
                      });
                      isValid = false;
                    }

                    $mssgsHeader.removeClass('-search-mode');
                    $mssgsSearchField.val('');
                    mssgsWidgetParams.searchQuery = '';
                    isSearchMode = false;
                    getMessages(mssgsWidgetParams.model.filter, 0, mssgsWidgetParams.searchQuery, refreshMssgsList);
                  });
                }

                return isValid;
              }
            }],
            afterOpen: function afterOpen() {
              modalService.setTitle(); //LKCommon.initSelectric($('#ServiceInstanceCreateDialog .select'));
            }
          });
        });
      }
    });
    $(document).on('click', '#moreServicesBtn', function () {
      var $this = $(this);
      var $servicesMenu = $('#serviceMssgsList');
      var $servicesSubMenus = $('.context-menu-link.-has-children');
      var $servicesHiddenItems = $('.context-menu-item[data-hidden="1"]');

      if ($servicesMenu.hasClass('-show-all')) {
        $servicesMenu.removeClass('-show-all');
        $servicesSubMenus.removeClass('-open-menu');
        $servicesHiddenItems.hide();
        $this.text('Посмотреть все сервисы');
      } else {
        $servicesMenu.addClass('-show-all');
        $servicesSubMenus.addClass('-open-menu');
        $servicesHiddenItems.show();
        $this.text('Скрыть сервисы');
      }
    });
  }

  function unbindHandlers() {
    $(document).off('click', '#searchMssgsBtn');
    $(document).off('click', '#closeSearchMssgs');
    $(document).off('keyup', '#searchMssgsField');
    $(document).off('click', '#moreMssgsBtn');
    $(document).off('click', '.mssg-section-link');
    $(document).off('click', '.appartment-mssgs-services .service-group');
    $(document).off('click', '.appartment-mssgs-services .service-item');
    $(document).off('click', '#moreServicesBtn');
  }

  function init(mssgsParams) {
    unbindHandlers();
    setParams(mssgsParams);
    cacheNodes();
    compileTemplates();
    bindHandlers();
  }

  return {
    init: init
  };
}();